import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";

import FactoryIcon from "@mui/icons-material/Factory";

import OverviewProductStorageTab from "./innertabs/ProductStorage";
import OverviewOccupantsTab from "./innertabs/Occupants";
import OverviewLogisticsTab from "./innertabs/Logistics";
import {
  LogisticsIcon,
  OccupantsIcon,
  ProductStorageIcon,
} from "../../../../icons";
import ILocation from "../../../../types/ILocation";
import { useNitroStore } from "../../../../store/Store";
import OverviewFacilityTab from "./innertabs/Facility";
import LoadingIcon from "../../../../components/Loading";

const OverviewTab = ({
  location,
  reloadLocation,
}: {
  location?: ILocation;
  reloadLocation: () => Promise<void>;
}) => {
  const [tab, setTab, insightsEditing] = useNitroStore((state) => [
    state.insightOverviewTab,
    state.setInsightOverviewTab,
    state.insightsEditing,
  ]);
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        minHeight: 0,
      }}
    >
      {insightsEditing === undefined && (
        <BottomNavigation
          style={{ height: 80, minHeight: 80, backgroundColor: "#F7F7F7" }}
          showLabels
          value={tab}
          onChange={(e, newValue) => setTab(newValue)}
        >
          <BottomNavigationAction
            disabled={insightsEditing !== undefined}
            label="Logistics"
            value="Logistics"
            icon={
              <LogisticsIcon
                color={tab === "Logistics" ? "#005CA6" : "rgb(0,0,0,.6)"}
              />
            }
          />

          <BottomNavigationAction
            disabled={insightsEditing !== undefined}
            label={<div style={{ position: "relative" }}>Product storage</div>}
            value="ProductStorage"
            icon={
              <ProductStorageIcon
                color={tab === "ProductStorage" ? "#005CA6" : "rgb(0,0,0,.6)"}
              />
            }
          />
          <BottomNavigationAction
            disabled={insightsEditing !== undefined}
            label={<div style={{ position: "relative" }}>Occupants</div>}
            value="Occupants"
            icon={
              <OccupantsIcon
                color={tab === "Occupants" ? "#005CA6" : "rgb(0,0,0,.6)"}
              />
            }
          />
          <BottomNavigationAction
            disabled={insightsEditing !== undefined}
            label="Facility"
            value="Facility"
            icon={
              <FactoryIcon
                style={{
                  color: tab === "Facility" ? "#005CA6" : "rgb(0,0,0,.6)",
                }}
              />
            }
          />
        </BottomNavigation>
      )}
      {/* BODY */}
      {!location && (
        <div>
          <LoadingIcon />
        </div>
      )}

      {location && (
        <div
          style={{
            flexGrow: 1,
            display: "flex",
            width: "100%",
            // minHeight: 0,
            overflowY: "auto",
            overflowX: "hidden",
            paddingTop: 10,
          }}
        >
          {tab === "Logistics" && (
            <OverviewLogisticsTab
              location={location}
              reloadLocation={reloadLocation}
            />
          )}
          {tab === "ProductStorage" && (
            <OverviewProductStorageTab
              occupants={location?.occupants || []}
              uom={location?.uom as any}
            />
          )}
          {tab === "Occupants" && (
            <OverviewOccupantsTab
              locationId={location.id}
              occupants={location?.occupants || []}
              uom={location.uom}
              reloadLocation={reloadLocation}
            />
          )}
          {tab === "Facility" && (
            <OverviewFacilityTab
              location={location}
              reloadLocation={reloadLocation}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default OverviewTab;
